export const GOVERNED_SPORTS = Object.freeze(["MLB", "NBA", "WNBA", "NFL", "CFB", "SOCCER", "KBO", "NHL"]);

export const isActualSportTransition = (fromSport, toSport) => {
  const from = String(fromSport || "").trim().toUpperCase();
  const to = String(toSport || "").trim().toUpperCase();
  return Boolean(to && from !== to);
};

export const sportOnlyUrl = (href, sport) => {
  const url = new URL(href);
  url.search = "";
  url.searchParams.set("sport", String(sport || "").toUpperCase());
  return url;
};

export const normalizeUnsupportedDirectionUrl = (href, sport) => {
  const url = new URL(href);
  const sportKey = String(sport || "").trim().toUpperCase();
  const direction = String(url.searchParams.get("direction") || "").trim().toUpperCase();
  if (sportKey !== "NHL" || direction !== "WAIT") return null;
  url.searchParams.delete("direction");
  return `${url.pathname}${url.search}${url.hash}`;
};

export const sportTransitionDefaults = () => ({
  games: [], search: "", propType: "", propTypes: [], direction: "ALL",
  classifications: [], lineTypes: [], risk: [], injuries: "ALL", taxonomy: "ALL",
  recentForm: [], formations: [], minutes: [], guruPick: "", queryFilters: {},
});

export const destinationDatasetState = ({ activeSport, loadedSport, loading = false, error = "", rawCount = 0, filteredCount = 0 } = {}) => {
  const active = String(activeSport || "").trim().toUpperCase();
  const loaded = String(loadedSport || "").trim().toUpperCase();
  if (loading || !loaded || active !== loaded) return "LOADING";
  if (error) return "UNAVAILABLE";
  if (Number(rawCount) > 0 && Number(filteredCount) === 0) return "FILTERED_EMPTY";
  if (Number(rawCount) === 0) return "NO_GOVERNED_ROWS";
  return "READY";
};
